import { render } from "./Inactivo.vue?vue&type=template&id=5dd1ff84&ts=true"
import script from "./Inactivo.vue?vue&type=script&lang=ts"
export * from "./Inactivo.vue?vue&type=script&lang=ts"

import "./Inactivo.vue?vue&type=style&index=0&id=5dd1ff84&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__